import type { ButtonHTMLAttributes, CSSProperties } from "react";

type Variant = "default" | "primary" | "outline" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const variantStyles: Record<Variant, CSSProperties> = {
  default: {
    background: "transparent",
    border: "1px solid var(--comp-rule)",
    color: "var(--fg-1)",
  },
  primary: {
    background: "var(--comp-ink)",
    border: "1px solid var(--comp-ink)",
    color: "var(--adj-white)",
  },
  outline: {
    background: "transparent",
    border: "1px solid var(--comp-rule)",
    color: "var(--fg-2)",
  },
  danger: {
    background: "transparent",
    border: "1px solid var(--comp-salmon)",
    color: "var(--comp-salmon)",
  },
};

export function Button({
  variant = "default",
  style,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      style={{
        padding: "4px 10px",
        borderRadius: 0,
        fontWeight: 500,
        fontSize: 11,
        fontFamily: "var(--font-mono)",
        textTransform: "lowercase",
        cursor: props.disabled ? "not-allowed" : "pointer",
        opacity: props.disabled ? 0.6 : 1,
        ...variantStyles[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
}
